<template>
  <tr>
    <td v-text="productWarehouse.short_name"></td>
    <td class="text-right" v-text="productWarehouse.stock_rotations.length ? productWarehouse.stock_rotations[0].quantity_sum : 0"></td>
    <td class="text-right">
      <span v-if="! editMode">{{ productWarehouseConfig ? productWarehouseConfig.warnschwelle : null }}</span>
      <input v-else class="form-control quick-input" v-model="configToEdit.warnschwelle">
    </td>
    <td class="text-right">
      <span v-if="! editMode">{{ productWarehouseConfig ? productWarehouseConfig.soll_menge : null }}</span>
      <input v-else class="form-control quick-input" v-model="configToEdit.soll_menge">
    </td>
    <td class="text-right">
      <div class="td-actions">
        <template v-if="editMode">
          <button class="btn btn-success btn-link btn-xs"
            v-tooltip.top-center="'Speichern'"
            @click="saveEdit"
          >
            <i class="fas fa-check"></i>
          </button>
          <button class="btn btn-danger btn-link btn-xs"
            v-tooltip.top-center="'Cancel'"
            @click="exitEditMode"
          >
            <i class="fa fa-close"></i>
          </button>
        </template>
        <template v-else>
          <button class="btn btn-warning btn-link btn-xs"
            v-tooltip.top-center="'Bearbeiten'"
            @click="enterEditMode"
          >
            <i class="fas fa-edit"></i>
          </button>
          <button v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
            @click="deleteConfig"
          >
            <i class="fa fa-close"></i>
          </button>
        </template>
      </div>
    </td>
  </tr>
</template>

<script>

export default {
  props: ['productWarehouse'],
  data () {
    return {
      editMode: false,
      configToEdit: {
        id: null,
        soll_menge: null,
        warnschwelle: null,
        warehouse_id: this.productWarehouse.id
      }
    }
  },
  methods: {
    enterEditMode () {
      if (this.productWarehouseConfig) {
        this.configToEdit.id = this.productWarehouseConfig.id
        this.configToEdit.soll_menge = this.productWarehouseConfig.soll_menge
        this.configToEdit.warnschwelle = this.productWarehouseConfig.warnschwelle
      } else {
        this.configToEdit.id = null
        this.configToEdit.soll_menge = null
        this.configToEdit.warnschwelle = null
      }
      this.editMode = true
    },
    exitEditMode () {
      this.editMode = false
    },
    saveEdit () {
      let res = null
      if (this.productWarehouseConfig) {
        res = this.$http.put(`/products/${this.$route.params.id}/warehouse_config/${this.productWarehouseConfig.id}`, this.configToEdit).then(({ data }) => {
          this.productWarehouseConfig.soll_menge = data.soll_menge
          this.productWarehouseConfig.warnschwelle = data.warnschwelle
        })
      } else {
        res = this.$http.post(`/products/${this.$route.params.id}/warehouse_config`, this.configToEdit).then(({ data }) => {
          this.productWarehouse.product_configs.push(data)
        })
      }
      res.then(() => (this.editMode = false))
    },
    deleteConfig () {
      if (this.productWarehouseConfig && confirm('Warnschwellen & Sollmengen Konfiguration löschen?')) {
        this.$http.delete(`/products/${this.$route.params.id}/warehouse_config/${this.productWarehouseConfig.id}`).then(() => {
          this.productWarehouse.product_configs.splice(0, 1)
        })
      }
    }
  },
  computed: {
    productWarehouseConfig () {
      return this.productWarehouse.product_configs.length ? this.productWarehouse.product_configs[0] : null
    }
  }
}
</script>
